import React from 'react'

interface LabeledProps extends React.HTMLAttributes<HTMLDivElement> {
  label: React.ReactNode
  value?: React.ReactNode
  children?: React.ReactNode
}

const Labeled = ({ label, value = null, children = null, ...otherAttrs }: LabeledProps) => (
  <div {...otherAttrs}>
    <div className="text-xs text-gray-500 mb-1">{label}&nbsp;</div>
    <div className="font-medium">
      {value ? value : children}
    </div>
  </div>
)

export default Labeled
